module.exports = __webpack_public_path__ + "media/images/laptop-screen-9a6256b3.png";